function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EventEmitter);

    var self = this;
    self.params = params; // Events

    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== "function") return self;
      var method = priority ? "unshift" : "push";
      events.split(" ").forEach(function (event) {
        if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
        self.eventsListeners[event][method](handler);
      });
      return self;
    }
  }, {
    key: "once",
    value: function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== "function") return self;

      function onceHandler() {
        self.off(events, onceHandler);

        if (onceHandler.f7proxy) {
          delete onceHandler.f7proxy;
        }

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(self, args);
      }

      onceHandler.f7proxy = handler;
      return self.on(events, onceHandler, priority);
    }
  }, {
    key: "off",
    value: function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) return self;
      events.split(" ").forEach(function (event) {
        if (typeof handler === "undefined") {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    }
  }, {
    key: "emit",
    value: function emit() {
      var self = this;
      if (!self.eventsListeners) return self;
      var events;
      var data;
      var context;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (typeof args[0] === "string" || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }

      var eventsArray = Array.isArray(events) ? events : events.split(" ");
      eventsArray.forEach(function (event) {
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    }
  }]);

  return EventEmitter;
}();

function rgbToHex(value) {
  var sColor = [value.r.toString(), value.g.toString(), value.b.toString()];
  value = '';
  sColor.map(function (v) {
    v = parseInt(v.replace(/[^\d]/gi, ''), 10).toString(16);
    value += v.length == 1 ? '0' + v : v;
  }).join('');
  return '0x' + value;
}

function initKr(dom, xml, id, js, swf) {
  var _this = this;

  var krpano = null;
  var xmlPrefix = xml.slice(0, 4);
  var xmlExt = xml.slice(-4);
  var data = {
    swf: swf,
    xml: '',
    id: id,
    target: dom,
    html5: "auto",
    mobilescale: 1.0,
    passQueryParameters: true,
    consolelog: false
  };

  if (xmlPrefix === 'http' || xmlExt === '.xml') {
    data.xml = xml;
  } else {
    xml = xml;
  }

  return new Promise(function (resolve, reject) {
    // loadPano(js).then(krJs => {
    //   console.log(krJs)
    //   krJs.
    embedpano(_objectSpread2(_objectSpread2({}, data), {}, {
      onready: function onready(krpano_interface) {
        krpano = krpano_interface.get('global');

        if (xmlPrefix !== 'http' && xmlExt !== '.xml') {
          krpano.call('loadxml(' + xml + ')');
        } //xml加载完成
        // krpano.set('events.onready',()=>{
        //   this.emit('onready',krpano_interface);
        // });
        // this.emit('onready',krpano_interface); //新版不可用
        //XML加载完成


        krpano.set('events.onxmlcomplete', function () {
          // onready(krpano_interface);
          _this.emit('onxmlcomplete', krpano_interface);
        }); // //设置切换到全屏模式时显示执行的动作
        // krpano.set('events.onenterfullscreen',()=>{
        //     this.emit('onenterfullscreen');
        // });
        // //设置当退出全屏模式时执行的动作
        // krpano.set('events.onexitfullscreen',()=>{
        //     this.emit('onexitfullscreen');
        // });
        // //设置新全景图加载时执行的动作
        // krpano.set('events.onnewpano',()=>{
        //   console.log(222)
        //     this.emit('onnewpano');
        // });
        // //当前场景被关闭时
        // krpano.set('events.onremovepano',()=>{
        //   console.log(333)
        //     this.emit('onremovepano');
        //     this.timers.map(item => {
        //         clearInterval(item);
        //         this.timers = [];
        //     })
        // });
        // //设置当新场景被加载时执行的动作
        // krpano.set('events.onnewscene',()=>{
        //     this.emit('onnewscene');
        // });
        // //单击鼠标执行的动作
        // krpano.set('events.onsingleclick',()=>{
        //     this.emit('onsingleclick');
        // });
        // //双击鼠标执行的动作
        // krpano.set('events.ondoubleclick',()=>{
        //     this.emit('ondoubleclick');
        // });
        // //设置读取错误时执行的动作
        // krpano.set('events.onxmlerror',(e)=>{
        //     console.log(e,'onxmlerror')
        //     this.emit('onxmlerror');
        // });
        // //设置读取错误时执行的动作
        // krpano.set('events.onloaderror',(e)=>{
        //     console.log(e,'onloaderror')
        //     this.emit('onloaderror');
        // });

        resolve(krpano);
      }
    })); // });
  });
}

var Init = {
  initKr: initKr
};

var Kr = _objectSpread2({}, Init);

function animate(krpano, name, imgObj) {
  krpano.set('hotspot[' + name + '].crop', "0|0|" + Number(imgObj.fwidth) + "|" + Number(imgObj.fheight));
  krpano.set('hotspot[' + name + '].framewidth', Number(imgObj.fwidth));
  krpano.set('hotspot[' + name + '].frameheight', Number(imgObj.fheight));
  krpano.set('hotspot[' + name + '].imgwidth', Number(imgObj.imgwidth));
  krpano.set('hotspot[' + name + '].imgheight', Number(imgObj.imgheight));
  krpano.set('hotspot[' + name + '].frame', 0);
  krpano.set('hotspot[' + name + '].frameoff', 0);
  krpano.set('hotspot[' + name + '].framespeed', Number(imgObj.pertime));
  krpano.set('hotspot[' + name + '].lastframe', Number(imgObj.total));
  krpano.set('hotspot[' + name + '].onloaded', 'hotspot_animate();'); // return hotspot_animate(krpano,name,imgObj);
}

var textfieldSwf = '//res.jsvry.cn/krpano/plugins/textfield.swf';
var snowJs = '//res.jsvry.cn/krpano/plugins/snow.js';
var snowSwf = '//res.jsvry.cn/krpano/plugins/snow.swf';
var videoJs = '//test.res.jsvry.cn/krpano/plugin/common/video/myvideoplay.js';
var videoSwf = '//test.res.jsvry.cn/krpano/plugins/videoplayer.swf';

//默认热点文字样式
var defaultHotspotTitle = {
  backgroundcolor: '#000000',
  backgroundalpha: 0.5,
  roundedge: 3,
  css: 'font-size:14px;color:#ffffff;padding:2px 6px;font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";',
  edge: 'bottom',
  ox: '0',
  oy: '-60',
  zorder: 11,
  zoom: true
}; //默认评论文字样式

var commentHotspotTitle = _objectSpread2(_objectSpread2({}, defaultHotspotTitle), {}, {
  edge: 'left',
  ox: 22,
  oy: -35,
  height: 30
}); //默认嵌入文字样式


var defaultEmbedTitle = {
  backgroundcolor: '#000000',
  backgroundalpha: 0.5,
  roundedge: 3,
  css: 'line-height:26px;padding:0 8px;font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:14px;color:#ffffff;',
  edge: 'bottom',
  ox: 0,
  oy: -6,
  zorder: 5,
  zoom: true
}; //特效默认数据

var defaultEffect = {
  1: {
    mode: 'image',
    blendmode: 'normal',
    floor: 1,
    flakes: 300,
    speed: 2,
    imagescale: 0.5,
    shake: 1,
    speedvariance: 5,
    spreading: 2,
    wind: 0.2
  },
  2: {
    mode: 'image',
    blendmode: 'normal',
    floor: 1,
    flakes: 600,
    speed: 3,
    imagescale: 0.5,
    shake: 2,
    speedvariance: 5,
    spreading: 2,
    wind: 0.2
  },
  3: {
    mode: 'image',
    blendmode: 'normal',
    floor: 1,
    flakes: 1500,
    speed: 4,
    imagescale: 0.5,
    shake: 2,
    speedvariance: 5,
    spreading: 2,
    wind: 0.2
  }
};

function title(krpano, name, data, titleData) {
  var oy = Number(data.width) * Number(data.scale) * 0.5;
  var newData = '';

  if (data.hotspottype == 1) {
    newData = _objectSpread2(_objectSpread2(_objectSpread2({}, defaultHotspotTitle), titleData), {}, {
      oy: '-' + oy,
      css: defaultHotspotTitle.css.replace(/font-size:14px/, 'font-size:' + data.font_size + 'px')
    });
  } else {
    newData = _objectSpread2(_objectSpread2({}, defaultHotspotTitle), titleData);
  }

  var title_name = name + '_title';
  var h = krpano.get('hotspot[' + title_name + ']');

  if (!h) {
    krpano.actions.addhotspot(title_name);
  }

  krpano.set('hotspot[' + title_name + '].atv', data['atv']);
  krpano.set('hotspot[' + title_name + '].ath', data['ath']);
  krpano.set('hotspot[' + title_name + '].url', textfieldSwf);
  krpano.set('hotspot[' + title_name + '].html', data['title']);
  krpano.set('hotspot[' + title_name + '].onclick', data['onclick']);
  krpano.set('hotspot[' + title_name + '].zoom', data['zoom']);
  Object.keys(newData).map(function (item) {
    if (item == 'backgroundcolor' || item == 'backgroundalpha' || item == 'roundedge' || item == 'edge' || item == 'ox' || item == 'oy' || item == 'css' || item == 'zorder' || item == 'width' || item == 'height') {
      krpano.set('hotspot[' + title_name + '].' + item, newData[item]);
    }
  }); // 跟随场景变缩放变形
  // krpano.set('hotspot[' + title_name + '].distorted',true);
  // krpano.set('hotspot[' + title_name + '].rx',0);
  // krpano.set('hotspot[' + title_name + '].ry',0);
  // krpano.set('hotspot[' + title_name + '].rz',0);
}

function polypoint(krpano, name, data) {
  krpano.set('hotspot[' + name + '].fillcolor', rgbToHex(data['img'].bgColor));
  krpano.set('hotspot[' + name + '].fillalpha', data['img'].bgColor.a);
  krpano.set('hotspot[' + name + '].borderwidth', data['img'].borderWidth == 0 ? '0' : data['img'].borderWidth);
  krpano.set('hotspot[' + name + '].bordercolor', rgbToHex(data['img'].borderColor));
  krpano.set('hotspot[' + name + '].borderalpha', data['img'].borderColor.a);
  krpano.set('hotspot[' + name + '].onover', 'tween(fillcolor,' + rgbToHex(data['img'].hoverBgColor) + ');tween(fillalpha,' + data['img'].hoverBgColor.a + ');tween(borderwidth,' + data['img'].hoverBorderWidth + ');tween(bordercolor,' + rgbToHex(data['img'].hoverBorderColor) + ');tween(borderalpha,' + data['img'].hoverBorderColor.a + ');');
  krpano.set('hotspot[' + name + '].onout', 'tween(fillcolor,' + rgbToHex(data['img'].bgColor) + ');tween(fillalpha,' + data['img'].bgColor.a + ');tween(borderwidth,' + data['img'].borderWidth + ');tween(bordercolor,' + rgbToHex(data['img'].borderColor) + ');tween(borderalpha,' + data['img'].borderColor.a + ');');
  data['img'].point && data['img'].point.map(function (i, index) {
    krpano.set('hotspot[' + name + '].point[' + index + '].ath', i.ath);
    krpano.set('hotspot[' + name + '].point[' + index + '].atv', i.atv);
  });

  if (data['img'].clickIsShow == false) {
    krpano.set('hotspot[' + name + '].enabled', 'false');
  }
}

var commentBgImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAyCAYAAABLXmvvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM1MiwgMjAyMC8wMS8zMC0xNTo1MDozOCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTI4RDBGRjlGM0U1MTFFQUExRUVGOEM4OTMyRTE3RDYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTI4RDBGRkFGM0U1MTFFQUExRUVGOEM4OTMyRTE3RDYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5MjhEMEZGN0YzRTUxMUVBQTFFRUY4Qzg5MzJFMTdENiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5MjhEMEZGOEYzRTUxMUVBQTFFRUY4Qzg5MzJFMTdENiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg+XQQEAAAD1SURBVHja7Ne9CsIwEADgi5aCuIigz1LwYZwEcfE53HQVh6Lv0K76QE1DB0shMd5JBheHBJoO3sGVy5B8TX9IAtbaFPOEWdn+QzorFXg5AsAe4saB4AqLeWRYEmxhgBjBQMEwwwwzzDDDDDPMMMP9wHIAVxJ8GwC+wNehTcY+tIXetRVCTLH/M8rHhdgnf7X5d2KYYYYZ/mMYV6MMM6e667oztWPNeGuMuZdluWzb9oH1LmgcWo89UxVFscCuSV3XM2pjnfqOEwLnSqmNQ9fusU9iwJnW+kozJbRpmlXIjL23Pm63Qe80wRxjGkyN47x8xnkLMACpkSxb6LWCGgAAAABJRU5ErkJggg==";

function comment(krpano, name, data) {
  var hotspotName = name + '_comment_bg';
  var h = krpano.get('hotspot[' + hotspotName + ']');

  if (!h) {
    krpano.actions.addhotspot(hotspotName);
  }

  krpano.set('hotspot[' + hotspotName + '].atv', data['atv']);
  krpano.set('hotspot[' + hotspotName + '].ath', data['ath']);
  krpano.set('hotspot[' + hotspotName + '].url', commentBgImg);
  krpano.set('hotspot[' + hotspotName + '].edge', 'bottom');
  krpano.set('hotspot[' + hotspotName + '].ox', 0);
  krpano.set('hotspot[' + hotspotName + '].oy', 0);
  krpano.set('hotspot[' + hotspotName + '].zorder', 9); // krpano.set('hotspot[' + hotspotName + '].zoom',true);
}

function addHotspot(data) {
  var _this = this;

  var krpano = this.krpano;
  var h = krpano.get('hotspot[' + data.name + ']');

  if (!h) {
    krpano.actions.addhotspot(data.name);
  }

  Object.keys(data).map(function (item) {
    if (item != 'name') {
      if (data['hotspottype'] == 1 || data['hotspottype'] == 2) {
        //热点序列图
        if (item == 'img' && data[item].type == 2) {
          var timer = animate(krpano, data.name, data[item]);

          _this.timers.push(timer);
        } //多边型热点


        if (item == 'iconType' && data[item] == 3) {
          polypoint(krpano, data.name, data);
        } //热点标题


        if (item == 'showTitle' && data[item] == true && data['title']) {
          title(krpano, data.name, data);
        }
      } else if (data['hotspottype'] == 3) {
        comment(krpano, data.name, data);
        title(krpano, data.name, data, commentHotspotTitle);
      }

      krpano.set('hotspot[' + data.name + '].' + item, data[item]);
    }
  });
  krpano.set('hotspot[' + data.name + '].zorder', 10);
  krpano.set('hotspot[' + data.name + '].zoom', false); // 跟随场景变缩放变形
  // krpano.set('hotspot[' + data.name + '].distorted',true);
  // krpano.set('hotspot[' + data.name + '].rx',0);
  // krpano.set('hotspot[' + data.name + '].ry',0);
  // krpano.set('hotspot[' + data.name + '].rz',0);
}

var AddHotspot = {
  addHotspot: addHotspot
};

function showHotspot(name) {
  var krpano = this.krpano;
  var type = krpano.get('hotspot[' + name + '].hotspottype');
  krpano.call('set(hotspot[' + name + '].visible,true');

  switch (type) {
    case 1:
      krpano.call('set(hotspot[' + name + '_title].visible,true');
      break;

    case 2:
      break;

    case 3:
      krpano.call('set(hotspot[' + name + '_title].visible,true');
      krpano.call('set(hotspot[' + name + '_comment_bg].visible,true');
      break;

    case 4:
      krpano.call('set(hotspot[' + name + '_embed_arrow].visible,true');
      break;

    case 5:
      break;

    case 6:
      krpano.call('set(hotspot[' + name + '_btn].visible,true');
      break;
  }
}

var ShowHotspot = {
  showHotspot: showHotspot
};

function hideHotspot(name) {
  var krpano = this.krpano;
  var type = krpano.get('hotspot[' + name + '].hotspottype');
  krpano.call('set(hotspot[' + name + '].visible,false');

  switch (type) {
    case 1:
      krpano.call('set(hotspot[' + name + '_title].visible,false');
      break;

    case 2:
      break;

    case 3:
      krpano.call('set(hotspot[' + name + '_title].visible,false');
      krpano.call('set(hotspot[' + name + '_comment_bg].visible,false');
      break;

    case 4:
      krpano.call('set(hotspot[' + name + '_embed_arrow].visible,false');
      break;

    case 5:
      break;

    case 6:
      krpano.call('set(hotspot[' + name + '_btn].visible,false');
      break;
  }
}

var HideHotspot = {
  hideHotspot: hideHotspot
};

function removeHotspot(name) {
  var krpano = this.krpano;
  var type = krpano.get('hotspot[' + name + '].hotspottype');
  krpano.removehotspot(name);

  switch (type) {
    case 1:
      krpano.removehotspot(name + '_title');
      break;

    case 2:
      break;

    case 3:
      krpano.removehotspot(name + '_title');
      krpano.removehotspot(name + '_comment_bg');
      break;

    case 4:
      krpano.removehotspot(name + '_embed_arrow');
      break;

    case 5:
      break;

    case 6:
      krpano.removehotspot(name + '_btn');
      break;
  }
}

var RemoveHotspot = {
  removeHotspot: removeHotspot
};

var Hotspot = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, AddHotspot), ShowHotspot), HideHotspot), RemoveHotspot);

function text(krpano, name, data) {
  krpano.set('hotspot[' + name + '].html', data.actionData.text ? data.actionData.text : '');
  krpano.set('hotspot[' + name + '].url', textfieldSwf);
  krpano.set('hotspot[' + name + '].hotspottype', data.hotspottype);
  krpano.set('hotspot[' + name + '].ath', data.locationData.ath);
  krpano.set('hotspot[' + name + '].atv', data.locationData.atv);
  Object.keys(defaultEmbedTitle).map(function (item) {
    if (item == 'backgroundcolor' || item == 'backgroundalpha' || item == 'roundedge' || item == 'css' || item == 'edge' || item == 'ox' || item == 'oy' || item == 'zorder' || item == 'zoom' || item == 'width' || item == 'height') {
      krpano.set('hotspot[' + name + '].' + item, defaultEmbedTitle[item]);
    }
  });
}

var arrowImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAcCAYAAAAjmez3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkEzRkFDQzY1MzFFOTExRUE4QjNBOTEwRkJGQzg3N0E2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkEzRkFDQzY2MzFFOTExRUE4QjNBOTEwRkJGQzg3N0E2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTNGQUNDNjMzMUU5MTFFQThCM0E5MTBGQkZDODc3QTYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTNGQUNDNjQzMUU5MTFFQThCM0E5MTBGQkZDODc3QTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6qaVkzAAABCUlEQVR42tSWsQ4BQRRFLxvNNgrRiHIbX6DXafyAL1idr1iVklLjB1QqnUKtVYlOTSERvEmmECHsm53x3klus1PdZHbOBYAR5a48EwpKlLniEgtKBEvFftBWYkOJ8UJsD7SU2FHq+ECNslVQ4khJ8IUm5SC4xJnSxo+0bGtpJa6UHnLStu0lFUnBpEu5SHKFC33KTZIrXBhKc4ULmTRXcDFTZibNFVyiQFMmlyu4mPu6luYKLlWPUyZFYMyU2RdcYow/kRQ4ZQpzBRfzU56kuYJLx2HKeHFF6Cnj1RUuDKS5wveUCeoKlykzleYKH1MmgzLMc7p644oyFPI8ZcS4gkuDsvTtiocAAwA4lrmEBwXKTgAAAABJRU5ErkJggg==";

function textArrow(krpano, name, data) {
  var hotspotName = name + '_embed_arrow';
  var h = krpano.get('hotspot[' + hotspotName + ']');

  if (!h) {
    krpano.actions.addhotspot(hotspotName);
  }

  krpano.set('hotspot[' + hotspotName + '].atv', data.locationData.atv);
  krpano.set('hotspot[' + hotspotName + '].ath', data.locationData.ath);
  krpano.set('hotspot[' + hotspotName + '].url', arrowImg);
  krpano.set('hotspot[' + hotspotName + '].width', 10);
  krpano.set('hotspot[' + hotspotName + '].height', 6);
  krpano.set('hotspot[' + hotspotName + '].edge', 'bottom');
  krpano.set('hotspot[' + hotspotName + '].ox', 0);
  krpano.set('hotspot[' + hotspotName + '].oy', 0);
  krpano.set('hotspot[' + hotspotName + '].zorder', 20);
  krpano.set('hotspot[' + hotspotName + '].zoom', true);
}

function animate$1(krpano, name, data) {
  var actionData = data.actionData;
  var locationData = data.locationData;
  krpano.set('hotspot[' + name + '].url', actionData.url);
  krpano.set('hotspot[' + name + '].crop', "0|0|" + actionData.playTime.fwidth + "|" + actionData.playTime.fheight);
  krpano.set('hotspot[' + name + '].framewidth', actionData.playTime.fwidth);
  krpano.set('hotspot[' + name + '].frameheight', actionData.playTime.fheight);
  krpano.set('hotspot[' + name + '].imgwidth', actionData.playTime.imgwidth);
  krpano.set('hotspot[' + name + '].imgheight', actionData.playTime.imgheight);
  krpano.set('hotspot[' + name + '].frame', '0');
  krpano.set('hotspot[' + name + '].frameoff', '0');
  krpano.set('hotspot[' + name + '].framespeed', actionData.playTime.pertime);
  krpano.set('hotspot[' + name + '].lastframe', actionData.playTime.total);
  krpano.set('hotspot[' + name + '].onloaded', 'hotspot_animate();');
  Object.keys(locationData).map(function (item) {
    krpano.set('hotspot[' + name + '].' + item, locationData[item]);
  }); // return hotspot_animate(krpano,name,actionData.playTime);
}

function video(krpano, name, data) {
  krpano.set('hotspot[' + name + '].url', videoJs);
  krpano.set('hotspot[' + name + '].alturl', videoSwf);
  krpano.set('hotspot[' + name + '].pausedonstart', true);
  krpano.set('hotspot[' + name + '].directionalsound', true);
  krpano.set('hotspot[' + name + '].capture', false);
  krpano.set('hotspot[' + name + '].range', 200);
  krpano.set('hotspot[' + name + '].onclick', 'closeVideoo(get(name));');
  krpano.set('hotspot[' + name + '].visible', true);
  krpano.set('hotspot[' + name + '].zorder', 5);
  krpano.set('hotspot[' + name + '].distorted', true);
  Object.keys(data).map(function (item) {
    if (item == 'locationData') {
      krpano.set('hotspot[' + name + '].onloaded', "embed_video(" + data.locationData.scale + "," + data.locationData.rx + "," + data.locationData.ry + "," + data.locationData.rz + ");setVideoBtn(" + name + ");");
    } else if (item == 'actionData') {
      krpano.set('hotspot[' + name + '].videourl', data.actionData.videoUrl);
      krpano.set('hotspot[' + name + '].posterurl', data.actionData.thumbUrl);
      krpano.set('hotspot[' + name + '].loop', data.actionData.loop);
      krpano.set('hotspot[' + name + '].volume', data.actionData.volume);
    } else {
      krpano.set('hotspot[' + name + '].' + item, data[item]);
    }
  });
}

function addEmbed(data) {
  var _this = this;

  var krpano = this.krpano;
  var h = krpano.get('hotspot[' + data.name + ']');

  if (!h) {
    krpano.actions.addhotspot(data.name);
  }

  Object.keys(data).map(function (item) {
    if (item != 'name') {
      if (data.type == 1) {
        text(krpano, data.name, data);
        textArrow(krpano, data.name, data);
      } else if (data.type == 2) {
        console.log('图片列表');
      } else if (data.type == 3) {
        var timer = animate$1(krpano, data.name, data);

        _this.timers.push(timer);
      } else {
        console.log('视频');
        video(krpano, data.name, data);
      } //krpano.set('hotspot[' + data.name + '].'+ item, data[item]);

    }
  });
  krpano.set('hotspot[' + data.name + '].zorder', 10);
  krpano.set('hotspot[' + data.name + '].zoom', true);
}

var AddEmbed = {
  addEmbed: addEmbed
};

var Embed = _objectSpread2({}, AddEmbed);

function setEffect(data) {
  var jsapi = this.krpano;

  if (data.type == 'system' || data.type == 'custom') {
    var effectname = 'snow';
    jsapi.call("addplugin(" + effectname + ");");
    jsapi.set('plugin[' + effectname + '].url', snowJs);
    jsapi.set('plugin[' + effectname + '].alturl', snowSwf);
    Object.keys(data).map(function (item) {
      //获取大中小属性后取默认值
      if (item == 'effect_size') {
        data.effect_size && Object.keys(defaultEffect[data.effect_size]).map(function (j) {
          jsapi.set('plugin[' + effectname + '].' + j, defaultEffect[data.effect_size][j]);
        });
      } //获取图片时set图片


      if (item == 'imageurl') {
        jsapi.set('plugin[' + effectname + '].' + item, data[item]);
      }
    });
    jsapi.set('plugin[' + effectname + '].zorder', 1);
  } else if (data.type == 'sunlight') ;
}

var Effect = {
  setEffect: setEffect
};

var Effect$1 = _objectSpread2({}, Effect);

var Jtx = /*#__PURE__*/function (_Events) {
  _inherits(Jtx, _Events);

  var _super = _createSuper(Jtx);

  function Jtx(props) {
    var _this;

    _classCallCheck(this, Jtx);

    _this = _super.call(this, props);
    _this.props = _objectSpread2({}, props);
    _this.timers = []; //场景相关

    Object.keys(Kr).forEach(function (protoName) {
      if (!Jtx.prototype[protoName]) {
        Jtx.prototype[protoName] = Kr[protoName];
      }
    }); //热点相关

    Object.keys(Hotspot).forEach(function (protoName) {
      if (!Jtx.prototype[protoName]) {
        Jtx.prototype[protoName] = Hotspot[protoName];
      }
    }); //嵌入相关

    Object.keys(Embed).forEach(function (protoName) {
      if (!Jtx.prototype[protoName]) {
        Jtx.prototype[protoName] = Embed[protoName];
      }
    }); //特效相关

    Object.keys(Effect$1).forEach(function (protoName) {
      if (!Jtx.prototype[protoName]) {
        Jtx.prototype[protoName] = Effect$1[protoName];
      }
    }); //krpano对象抛到全局

    _this.initKr(_this.props.dom, _this.props.xml).then(function (re) {
      _this.krpano = re;
    });

    return _this;
  }

  return Jtx;
}(EventEmitter);

export default Jtx;
